import Access from './Access'

// 单例返回
const access = new Access()

export default access